import { AbstractControlOptions, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { Directive } from '@angular/core';

@Directive()
export abstract class EaDeductionFormBuilder extends PrFormAbstract {
  generate(entity: any) {
    let options: AbstractControlOptions = {};

    return this.formBuilder.group(
      {
        id: [entity ? entity.id : null],
        type: [entity.type ? entity.type : null, Validators.required],
        deductionAmount: [
          entity.deductionAmount ? entity.deductionAmount : null,
          Validators.required,
        ],
        label: [entity.label ? entity.label : null, Validators.required],
      },
      options,
    );
  }

  extract() {
    let dto: any = {
      id: this.emptyIsNull(this.form.value.id),
      type: this.emptyIsNull(this.form.value.type),
      deductionAmount: this.emptyIsNull(this.form.value.deductionAmount),
      label: this.emptyIsNull(this.form.value.label),
    };
    return dto;
  }
}
